import { Keys, locale } from 'src/i18n';
import { MyPDDLoan, MyPDDRecord } from './types';

const toNumber = (value: any) => Number(value || 0);

const toText = (value: any) => String(value ?? '');

export const getPDDCounts = (loan: MyPDDLoan) => [
  {
    label: locale(Keys.ABC_PDD_PENDING),
    value: loan.pendingPDD,
    critical: false,
  },
  {
    label: locale(Keys.ABC_PDD_CRITICAL),
    value: loan.criticalPDD,
    critical: true,
  },
];

const parseRecord = (record: any, index: number): MyPDDRecord => ({
  ...record,
  id: [
    toText(record?.LOAN_NO),
    toText(record?.FINVERSE_APPLICATION_NUMBER),
    toText(record?.doc_name),
    toText(record?.DOC_DEFFRED_DATE),
    toText(record?.CHANNEL_CODE),
    index,
  ].join('-'),
  loanNo: toText(record?.LOAN_NO),
  applicationNumber: toText(record?.FINVERSE_APPLICATION_NUMBER),
  customerName: toText(record?.customer_name),
  documentName: toText(record?.doc_name),
  documentDescription: toText(record?.DOC_DESC),
  documentCategory: toText(record?.Document_Category),
  channelCode: toText(record?.CHANNEL_CODE),
  deferredDate: toText(record?.DOC_DEFFRED_DATE),
  documentStatus: toText(record?.DOC_Status),
});

export const parseMyPDDResponse = (payload: any) => {
  const recordsByLoan = payload?.data || {};

  const loans: MyPDDLoan[] = Object.entries(recordsByLoan).map(
    ([loanNo, loanPayload]: [string, any]) => {
      const records = (loanPayload?.records || []).map(parseRecord);
      const firstRecord = records[0];

      return {
        loanNo,
        pendingPDD: toNumber(loanPayload?.Pending_PDD),
        criticalPDD: toNumber(loanPayload?.Critical_PDD),
        customerName: firstRecord?.customerName || '',
        applicationNumber: firstRecord?.applicationNumber || '',
        channelCode: firstRecord?.channelCode || '',
        records,
      };
    },
  );

  return {
    pendingPDD: toNumber(payload?.Pending_PDD),
    criticalPDD: toNumber(payload?.Critical_PDD),
    loans,
  };
};

export const getMyPDDErrorMessage = (error: any, fallbackMessage: string) => {
  const payload = error?.response?.data;

  return (
    payload?.error_message ||
    payload?.errorMessage ||
    payload?.message ||
    error?.message ||
    fallbackMessage
  );
};
